import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class OrganizationInfos extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }
    /**
     * Create model list from api return
     */
    static list(item) {
        return this.fromJSON(item);
    }

    static listUrl({ organizationId }) {
        return `/ticket/organizations/${organizationId}/infos`;
    }

    static getItemUrl(...args) {
        return this.getListUrl(...args);
    }
}
